import React, { useContext, useState, useEffect, useRef } from 'react';
import Card from 'antd/lib/card';
import ls from './ProgressBar.less';
import {env} from '../env';
import { StepsValidationStatusContext } from '../context/StepsValidationStatusProvider';
import { ModelContext } from './metadata/ModelSource';
import { DriversAndVehiclesDataReportContext } from '../context/DriversAndVehiclesDataReportProvider';
import { WorkflowStepsContext } from '../context/WorkflowStepsProvider';

import ProgressBarIcon from './ProgressBarIcon';

const ENABLE_NAVIGATION = env.enableNavigation;

const HorizontalProgressBar = ({
  moveTo,
  currentStep,
  hideNavLabels,
  isMobile,
  lineCd,
  position
}) => {
  const { stepsValidationStatus } = useContext(StepsValidationStatusContext);
  const model = useContext(ModelContext);
  const [showList, setShowList] = useState(false);
  const [currentListIndex, setCurrentListIndex] = useState(null);
  let { selectedDrivers, selectedRisks } = useContext(DriversAndVehiclesDataReportContext);
  const { disabledSteps } = useContext(WorkflowStepsContext);

  const Title = ({ title, index, labelRef }) => {
    const active = (index === currentStep);
    if (hideNavLabels === false) {
      return <span>{title}</span>;
    } else if (hideNavLabels) {
      return <span ref={active ? labelRef : null}>{active ? title : ''}</span>;
    } else {
      return null;
    }
  };

  const Steps = () => {
    const renderBeanList = (step, stepIndex, description) => {
      const { setScrollIndex } = useContext(StepsValidationStatusContext);

      const { key } = step;

      if (showList === false) return null;

      if (key === 'drivers') {
        const beansArray = model.getValue(key);
        if (!beansArray) return null;

        const allDeleted = beansArray.every(
          (bean) => {
            if (bean.status){
              const dtDriver = selectedDrivers.find(d=>d.id === bean.id)
              return (bean.status === 'Deleted'
                || ( bean.id && bean.id.indexOf('Prefill') > 0
                  && !dtDriver ));
            }else {
              return false;
            }
          }
        );

        if (allDeleted) return <p className={ls.text}>{description}</p>;

        return (
          <>
            {beansArray &&
              beansArray.map((bean, index) => {
                if (!bean.nameInfo) return null;
                if (bean.status && bean.status === 'Deleted') return null;
                const { givenName } = bean.nameInfo;
                const id = bean.id || bean._tempId;

                return (
                  <div
                    key={id}
                    className={ls.mouseHover}
                    onClick={() => {
                      moveTo(stepIndex);
                      setScrollIndex(index);
                    }}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '4px',
                    }}
                  >
                    <p className={ls.text}>{givenName}</p>
                  </div>
                );
              })}
          </>
        );
      }

      if (key === 'additionalInterests') {
        const path = 'ais';
        const beansArray = model.getValue(path);
        if (!beansArray) return null;
        const allDeleted = beansArray.every(
          (bean) => bean.status && bean.status === 'Deleted'
        );
        if (allDeleted) return <p className={ls.text}>{description}</p>;

        return (
          <>
            {beansArray &&
              beansArray.map((bean, index) => {
                if (!bean) return null;
                if (bean.status && bean.status === 'Deleted') return null;
                const { interestTypeCd, interestName } = bean;
                const id = bean.id || bean._tempId;

                return (
                  <div
                    key={id}
                    className={ls.mouseHover}
                    onClick={() => {
                      moveTo(stepIndex);
                      setScrollIndex(index);
                    }}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '4px',
                    }}
                  >
                    <p className={ls.text}>
                      {interestName} {interestTypeCd}
                    </p>
                  </div>
                );
              })}
          </>
        );
      }

      if (key === 'vehicles') {
        const path = `lines{lineCd:${lineCd}}.risks`;
        const beansArray = model.getValue(path);
        if (!beansArray) return null;

        const allDeleted = beansArray.every(
          (bean) => {
            if (bean.status){
              const dtRisk = selectedRisks.find(d=>d.id === bean.id)
              return (bean.status === 'Deleted'
                || ( bean.id && bean.id.indexOf('Prefill') > 0
                  && !dtRisk ));
            }else {
              return false;
            }
          }
        );

        if (allDeleted) return <p className={ls.text}>{description}</p>;

        return (
          <>
            {beansArray &&
              beansArray.map((bean, index) => {
                if (!bean.vehicle) return null;
                if (bean.status && bean.status === 'Deleted') return null;
                const { modelYr, manufacturer } = bean.vehicle;
                const id = bean.id || bean._tempId;
                return (
                  <div
                    key={id}
                    className={ls.mouseHover}
                    onClick={() => {
                      moveTo(stepIndex);
                      setScrollIndex(index);
                    }}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      marginTop: '4px',
                    }}
                  >
                    <p className={ls.text}>
                      {modelYr} {manufacturer}
                    </p>
                  </div>
                );
              })}
          </>
        );
      }

      // If the key is not one of the above use cases, display nothing.
      return null;
    };

    if (stepsValidationStatus) {
      return stepsValidationStatus.map((step, index) => {
        let { description, key, title, valid } = step;
        const stepIndex = index;

        const amountOfSteps = stepsValidationStatus.length;

        const stepsWidth = 100 / amountOfSteps;

        const issues = [];

        if (step.beanPathIssuesMatcher) {
          Object.keys(model.dataIssues.byPath)
            .filter((k) => k.match(step.beanPathIssuesMatcher))
            .forEach((k) =>
              model.dataIssues.byPath[k].forEach((issue) => issues.push(issue))
            );
        }

        valid = valid && issues.length === 0;

        return (
          <div
            key={key}
            aria-label={`${title} step`}
            className={ENABLE_NAVIGATION ? "mouse-hover-no-bgColor" : null}
            style={{
              opacity: disabledSteps.includes(step.key) ? 0.5: 1,
              alignSelf: 'center',
              margin: '8px',
              width: `${stepsWidth}%`,
              height: `${stepsWidth}px`,
              borderTop:
                currentStep === index || valid === true
                  ? '3px solid #00abdd'
                  : '3px solid #d0d9e1',
            }}
          >
            <div
              className="mouse-hover-no-bgColor"
              style={{ paddingTop: '10px', paddingBottom: '10px' }}
              onClick={() => {
                ENABLE_NAVIGATION ? moveTo(stepIndex, true, false) : null;
              }}
              onMouseEnter={() => {
                setShowList(true);
                setCurrentListIndex(index);
              }}
              onMouseLeave={() => {
                setShowList(false);
                setCurrentListIndex(null);
              }}
            >
              <h3
                className={ls.stepTitle}
                tabIndex={index}
                style={{ fontSize: '12px', textAlign: 'center' }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <ProgressBarIcon issues valid={valid} iconKey={key} index currentStep isMobile hideNavLabels/>
                  <Title title={title} index={index} labelRef={labelRef} />
                </div>
              </h3>
              {index === currentListIndex
                ? renderBeanList(step, stepIndex, description)
                : null}
            </div>
          </div>
        );
      });
    }
  };

  // Responsive navigation bar height only when nav labels are hidden (otherwise should be static)
  const minNavHeight = hideNavLabels ? 80 : 100;
  const [navHeight, setNavHeight] = useState(minNavHeight);
  const labelRef = useRef(null);

  useEffect(() => {
    if (hideNavLabels && labelRef.current) {
      setNavHeight(Math.max(minNavHeight, labelRef.current.clientHeight + 50));
    }
  });

  return (
    <Card
      style={{
        height: `${navHeight}px`,
        margin: '-25px -25px 15px -25px',
        top: position === 'fixed' ? '24px' : '',
        width: position === 'fixed' ? '100.75%' : '',
        position: `${position}`,
        zIndex: 999
      }}
      aria-label="Progress bar"
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignContent: 'center',
        }}
      >
        <Steps />
      </div>
    </Card>
  );
};

export default HorizontalProgressBar;
